module.exports = __webpack_public_path__ + "img/ecospot.41505036.png";